import { IReviewResponseDto } from './../../models/responses/review.response';
import { Component, Input, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-display-review',
  templateUrl: './display-review.component.html',
  styleUrls: ['./display-review.component.scss']
})
export class DisplayReviewComponent implements OnInit {
  @Input() review: IReviewResponseDto;
  environment = environment;
  constructor() { }

  ngOnInit(): void {
  }

}
